import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import englishServices from "../data/SdataEN";
import frenchServices from "../data/SdataFR";
import PricingCard from "../pricingCard/pricingCard.jsx";
import CustomPricingCard from "../pricingCard/CustomPricingCard.jsx";

const ServiceDetails = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentServiceState = location.state;

  const [services, setServices] = useState(
    i18n.language === "fr" ? frenchServices : englishServices
  );

  const [currentService, setCurrentService] = useState(() => {
    const initialServices = i18n.language === "fr" ? frenchServices : englishServices;
    return (
      initialServices.find(
        (s) => s.detailData.title === currentServiceState.title
      )?.detailData || currentServiceState
    );
  });

  useEffect(() => {
    const selectedServices = i18n.language === "fr" ? frenchServices : englishServices;
    setServices(selectedServices);

    const translatedService = selectedServices.find(
      (s) => s.detailData.id === currentServiceState.id
    );

    if (translatedService) {
      setCurrentService(translatedService.detailData);
    } else {
      setCurrentService(currentServiceState);
    }
  }, [i18n.language, currentServiceState]);

  const handleNavigateToService = (detailData) => {
    navigate("/service-details", {
      state: detailData,
    });
  };

  const otherServices = services.filter(
    (service) => service.detailData.title !== currentService.title
  );
 const packs = [
    {
      title: "Pack Platinium",
      price: "€185.50",
      image: "publicImages/plat.jpg",
      features: ["2.5 GB Space", "Free Domain Name", "Free Hosting plan"],
      buttonText: "Commander",
    },
    {
      title: "Pack Silver",
      price: "€198.50",
      image: "publicImages/sliv.jpg",
      features: ["1.5 GB Space", "Free Domain", "Standard Hosting"],
      buttonText: "Commander",
    },
    {
      title: "Pack Bronze",
      price: "€205.50",
      image: "publicImages/bronz.jpg",
      features: ["1 GB Space", "Subdomain", "Basic Hosting"],
      buttonText: "Commander",
    },
    {
      title: "Pack Gold",
      price: "€285.50",
      image: "publicImages/gold.jpg",
      features: ["1 GB Space", "Subdomain", "Basic Hosting"],
      buttonText: "Commander",
    },{
      title: "Pack  Diamond Maint-1",
      price: "€385.50",
      image: "publicImages/web.jpg",
      features: ["1 GB Space", "Subdomain", "Basic Hosting"],
      buttonText: "Commander",
    },{
      title: "Pack  Diamond Web-1",
      price: "€480.50",
      image: "publicImages/web.jpg",
      features: ["1 GB Space", "Subdomain", "Basic Hosting"],
      buttonText: "Commander",
    },{
      title: "Pack  Diamond Web-2",
      price: "€580.50",
      image: "publicImages/web.jpg",
      features: ["1 GB Space", "Subdomain", "Basic Hosting"],
      buttonText: "Commander",
    },
  ];
  return (
    <div className="container my-5">
      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <span></span>
        <div className="mt-5 text-center">
          <h5 className="mb-4">{t("service_details_title")}</h5>
          {otherServices.map((service, index) => (
            <button
              key={index}
              className="btn 
              blue-color-code text-white m-2"
              onClick={() => handleNavigateToService(service.detailData)}
            >
              {service.title}
            </button>
          ))}
        </div>
      </div>

      <h1 className="mb-3 mt-3">{currentService.title}</h1>
      <h4 className="mb-4 text-muted">{currentService.subtitle}</h4>

      <div className="row">
        {currentService.id === "1" ? (
          currentService.sections.map((section, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card p-3 h-100 shadow-sm text-center">
                <div className="text-center mb-2">
                  {section.image && (
                    <img
                      src={section.image}
                      alt={`${section.title} icon`}
                      className="img-fluid"
                      style={{
                        maxHeight: "500px",
                        objectFit: "cover",
                        width: "100%",
                        marginBottom: "10px",
                      }}
                    />
                  )}
                </div>
                <h5 className="mb-3">{section.title}</h5>
                <ul className="list-unstyled text-start">
                  {section.points.map((point, i) => (
                    <li
                      key={i}
                      style={{
                        color: "inherit",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))
        ) : currentService.id === "2" ? (
          currentService.sections.map((section, index) => (
            <div className="mb-4" key={index}>
              <div className="p-3 h-100 text-center">
                <ul className="list-unstyled text-start">
                  {section.points.map((point, i) => {
                    if (point.includes("Contact@stratEdgeos.lu")) {
                      return (
                        <li
                          key={i}
                          style={{ color: "inherit", whiteSpace: "pre-wrap" }}
                        >
                          <strong>Contact :</strong>{" "}
                          <a href="mailto:Contact@stratEdgeos.lu">
                            Contact@stratEdgeos.lu
                          </a>
                        </li>
                      );
                    }

                    if (point.includes("www.my-outsourcing.com")) {
                      return (
                        <li
                          key={i}
                          style={{ color: "inherit", whiteSpace: "pre-wrap" }}
                        >
                          <strong>
                            Plus d’informations sur le site de notre partenaire :
                          </strong>{" "}
                          <a
                            href="https://www.my-outsourcing.com"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            My Outsourcing
                          </a>
                        </li>
                      );
                    }

                    return (
                      <li
                        key={i}
                        style={{ color: "inherit", whiteSpace: "pre-wrap" }}
                      >
                        {point}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          ))
        ) : (
          <>
           
            <h5>« Grâce à nos partenaires dédiés, nous proposons des services de centre d’appels multilingues haute performance, adaptés aux particuliers et aux PME. 
Que vous cherchiez à développer votre service client ou à gérer des campagnes entrantes/sortantes, notre équipe vous garantit fiabilité et excellence de service. »</h5>

            {currentService.sections.map((section, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="card p-3 h-100 shadow-sm text-center">
                  <div className="text-center mb-2">
                    {section.image && (
                      <img
                        src={section.image}
                        alt={`${section.title} icon`}
                        className="img-fluid"
                        style={{
                          maxHeight: "500px",
                          objectFit: "cover",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      />
                    )}
                  </div>
                  <h5 className="mb-3">{section.title}</h5>
                  <ul className="list-unstyled text-start">
                    {section.points.map((point, i) => (
                      <li
                        key={i}
                        style={{
                          color: "inherit",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
            <h3>Pricing</h3>
             <div className="container d-flex justify-content-center my-5">

      <div className="container my-5">
      <div className="row g-4 justify-content-center">
        {packs.map((pack, index) => (
          <div key={index} className="col-md-4">
            <PricingCard {...pack} />
          </div>
        ))}
      </div>
    </div>

    </div>
        <div className="col-md-4">
        <CustomPricingCard
          title="Pack Plus"
          image="publicImages/price.png"
           buttonText="Commander"
        />
      </div>
          </>
          
        )}
      </div>
    </div>
  );
};

export default ServiceDetails;
